import React from 'react';
import { RadioButton } from 'sharedComponents/RadioButton';
import { setMaxPrecision } from 'helpers/formatters';
import { formatDateTime } from 'helpers/dateTimeFormatter';

export const TIMESTAMP_TABLE_COLUMN_KEYS = {
    RADIO: 'radio',
    TIMESTAMP: 'timestamp',
    SPEED: 'speed',
    LINE_FREQUENCY: 'lineFrequency',
    SKIN_TEMPERATURE: 'skinTemperature'
};

export const SORT_DIRECTION = {
    ASC: 'asc',
    DESC: 'desc'
};

export const TYPE_CONSTANTS = {
    TIMESTAMP: 'timestamp',
    NUMBER: 'number'
};

export const UNIT_OF_MEASUREMENT = {
    IMPERIAL: 'Imperial',
    METRIC: 'metric'
};

export const DATE_RANGE_ERROR_TOO_SHORT = 'tooShort';
export const DATE_RANGE_ERROR_TOO_LONG = 'tooLong';
export const DATE_RANGE_ERROR_OUTSIDE_RAW_DATA = 'outsideRawData';

export const minimumRequiredDaysRange = 7;
export const maximumDaysRange = 90;
export const numberOfMonthsInView = 2;
// eslint-disable-next-line import/no-unused-modules
export const oneYearInDays = 365;

export const MAX_PRECISION = 2;

export const getColumns = (
    translate,
    selectedTimestamp,
    setSelectedTimestamp,
    unitOfMeasurement = UNIT_OF_MEASUREMENT.METRIC,
    maxPrecision = 2
) => {
    // Set units based on unit of measurement
    const skinTemperatureUnit = unitOfMeasurement === UNIT_OF_MEASUREMENT.IMPERIAL ? '°F' : '°C';

    return [
        {
            width: 50,
            key: 'radio',
            title: '',
            filterIcon: false,
            render: (_, { timestamp }) => <RadioButton
                id={timestamp}
                checked={selectedTimestamp === timestamp}
                onClick={() => setSelectedTimestamp(timestamp)}
            />
        },
        {
            title: '',
            dataIndex: 'timestamp',
            key: 'timestamp',
            isSorting: true,
            width: 250,
            filterIcon: true,
            render: (timestamp) => formatDateTime(timestamp)
        },
        {
            title: '',
            dataIndex: 'speed',
            key: 'speed',
            isSorting: true,
            width: 200,
            filterIcon: true,
            render: (speed) => {
                if (speed !== null && speed !== undefined) {
                    const roundedSpeed = setMaxPrecision(speed, maxPrecision);
                    return `${roundedSpeed} rpm`;
                }
                return '-';
            }
        },
        {
            title: '',
            dataIndex: 'lineFrequency',
            key: 'lineFrequency',
            isSorting: true,
            width: 200,
            filterIcon: true,
            render: (lineFrequency) => {
                if (lineFrequency !== null && lineFrequency !== undefined) {
                    const roundedLineFrequency = setMaxPrecision(lineFrequency, maxPrecision);
                    return `${roundedLineFrequency} Hz`;
                }
                return '-';
            }
        },
        {
            title: '',
            dataIndex: 'skinTemperature',
            key: 'skinTemperature',
            isSorting: true,
            width: 200,
            filterIcon: true,
            render: (skinTemperature) => {
                if (skinTemperature !== null && skinTemperature !== undefined) {
                    const convertedTemp = unitOfMeasurement === 'Imperial'
                        ? skinTemperature * 9 / 5 + 32
                        : skinTemperature;
                    const roundedTemp = setMaxPrecision(convertedTemp, maxPrecision);
                    return `${roundedTemp} ${skinTemperatureUnit}`;
                }
                return '-';
            }
        },
    ];
};
